export default function EstadoCursoBadge({ activo }) {
  return activo ? (
    <span className="inline-flex rounded-full border border-success/30 bg-success/10 px-2.5 py-1 text-xs font-semibold text-success-text">Activo</span>
  ) : (
    <span className="inline-flex rounded-full border border-danger/25 bg-danger/10 px-2.5 py-1 text-xs font-semibold text-danger">Inactivo</span>
  )
}
